import { useEffect, useRef } from "react";
import { X } from "@phosphor-icons/react";
import CourtScoreboard from "../CourtScoreboard";

export default function MatchFullscreen({ match, court, onClose }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (el?.requestFullscreen) el.requestFullscreen().catch(() => {});
    const onChange = () => { if (!document.fullscreenElement) onClose(); };
    document.addEventListener("fullscreenchange", onChange);
    return () => document.removeEventListener("fullscreenchange", onChange);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const close = () => { if (document.fullscreenElement) document.exitFullscreen().catch(() => {}); onClose(); };

  if (!match) return null;

  return (
    <div ref={ref} className="fixed inset-0 z-[60]">
      <CourtScoreboard
        match={match}
        court={court}
        headerRight={
          <button data-testid="exit-fullscreen-btn" onClick={close} className="p-3 text-muted-foreground hover:text-white transition-colors">
            <X size={32} />
          </button>
        }
      />
    </div>
  );
}
